import React, { useEffect, useRef } from "react";
import { MessageTypes } from "./messageTypes";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import rehypeRaw from "rehype-raw";
import rehypeSanitize from "rehype-sanitize";

interface MessageBubbleProps {
    messages : MessageTypes[]
    isLoading:boolean
}

const MessageBubble = ({messages, isLoading}:MessageBubbleProps) => {

  const messageRef = useRef(null);

    const renderMarkdown = (content: string) => {
    return(
      <Markdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeRaw, rehypeSanitize]}
      >
        {content}
      </Markdown>
    )
  }

  const scrollToBottom = () => {
    messageRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(()=>{
    scrollToBottom();
  },[messages])



    return(
        <div className="flex-1 overflow-y-auto p-4 space-y-4"      
        >

        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`flex ${
              msg.sender === "user" ? "justify-end" : "justify-start"
            }`}
          >
            <div
              className={`max-w-[75%] px-4 py-2 rounded-lg text-sm ${
                msg.sender === "user"
                  ? "bg-black dark:bg-gray-700 text-white rounded-br-none"
                  : "bg-gray-100 dark:bg-gray-600 text-gray-800 dark:text-white rounded-bl-none"
              }`}
            >
               {
                msg.sender ==="bot" ?renderMarkdown(msg.message):msg.message
               }
            </div>
            <div ref={messageRef}/>
          </div>
        ))}

        {/* Typing indicator */}
        {isLoading && (
          <div className="flex justify-start">
            <div className="bg-gray-100 text-gray-800 rounded-lg rounded-bl-none px-4 py-2">
              <div className="flex space-x-1">
                <span className="animate-bounce">•</span>
                <span className="animate-bounce delay-100">•</span>
                <span className="animate-bounce delay-200">•</span>
              </div>
            </div>
          </div>
        )}

      </div>
    )
}
export default MessageBubble